import { createContext, useContext, useState, useEffect } from "react";
import { api, useAuth } from "./AuthContext";

const LeagueContext = createContext(null);

export function LeagueProvider({ children }) {
  const { user } = useAuth();
  const [leagues, setLeagues] = useState([]);
  const [currentLeague, setCurrentLeague] = useState(null);
  const [loading, setLoading] = useState(false);

  const loadLeagues = async () => {
    setLoading(true);
    try {
      const res = await api.get("/leagues");
      setLeagues(res.data);
      // Restore selected league from localStorage if still exists
      const saved = localStorage.getItem("currentLeagueId");
      if (saved && res.data.find((l) => l.id === saved)) {
        setCurrentLeague(res.data.find((l) => l.id === saved));
      } else if (res.data.length > 0) {
        selectLeague(res.data[0]);
      }
    } catch (e) {
      console.error("Kunde inte ladda ligor", e);
    } finally {
      setLoading(false);
    }
  };

  const selectLeague = (league) => {
    setCurrentLeague(league);
    localStorage.setItem("currentLeagueId", league.id);
  };

  const createLeague = async (name) => {
    const res = await api.post("/leagues", { name });
    await loadLeagues();
    selectLeague(res.data);
    return res.data;
  };

  useEffect(() => {
    if (user) {
      loadLeagues();
    } else {
      setLeagues([]);
      setCurrentLeague(null);
    }
  }, [user]);

  return (
    <LeagueContext.Provider value={{ leagues, currentLeague, selectLeague, createLeague, loadLeagues, loading }}>
      {children}
    </LeagueContext.Provider>
  );
}

export const useLeague = () => useContext(LeagueContext);
